import { type StepIconProps, styled } from "@mui/material";
import { Check } from "@mui/icons-material";
import { Colors } from "Components/Layout/Themes/Colors";

const StepIconRoot = styled("div")<{ ownerState: { active?: boolean } }>(
  ({ theme }) => ({
    color: Colors.MediumGrey,
    display: "flex",
    height: 22,
    alignItems: "center",
    "& .StepIcon-completedIcon": {
      color: theme.palette.primary.main,
      zIndex: 1,
      fontSize: 18,
    },
    "& .StepIcon-circle": {
      width: 8,
      height: 8,
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[700],
    }),
    variants: [
      {
        props: ({ ownerState }: { ownerState: { active?: boolean } }) =>
          ownerState.active,
        style: {
          color: theme.palette.primary.main,
        },
      },
    ],
  }),
);

export const StepIcon = ({ active, completed, className }: StepIconProps) => (
  <StepIconRoot ownerState={{ active }} className={className}>
    {completed ? (
      <Check className="StepIcon-completedIcon" />
    ) : (
      <div className="StepIcon-circle" />
    )}
  </StepIconRoot>
);
